<template>
    <div class="popup" :class="[{'open':visible}, `popup-${subClass}`]" :id="id+'Shadow'">
        <dialog
            class="popup__wrap"
            :id="id"
            v-if="visible"
            style="visibility: visible; display: flex; max-height: 95vh;border: none;"
            :style="specialStyles"
        >
                <div class="popup__close" v-if="!hideClose" @click.prevent.stop="hide"/>

                <div class="popup__title">
                    <slot name="title"></slot>
                </div>

                <div class="popup__scroller">
                  <div class="popup__content">
                      <slot></slot>
                  </div>
                </div>
        </dialog>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            default: 'vdialog-new'
        },
        subClass: {
            default: 'vdialog-new'
        },
        hideClose: {
            default: false
        },
        specialStyles: {
            type: Object, default: () => {}
        },
        onCloseEsc: {
            type: Function, default: null,
        }
    },
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        onKeyPress (event) {
            if (event.key && event.key === 'Enter') {
                if (event.target.className !== 'multiselect__input' && event.target.nodeName !== 'TEXTAREA')
                    event.preventDefault();
            }
        },
        show() {
            let promise = new Promise((resolve, reject) => {
                this.$nextTick().then(() => {
                    this.visible = true;
                    this.$emit('shown');
                    resolve(this);
                });
            })
            window.addEventListener("keydown", this.onKeyPress);
            return promise;
        },
        hide() {
            let promise = new Promise((resolve, reject) => {
                this.visible = false;
                this.$emit('hidden');
                resolve(this);
            })
            window.removeEventListener("keydown", this.onKeyPress);
            return promise;
        },
        toggle() {
            if (this.visible) {
                return this.hide();
            } else {
                return this.show();
            }
        },
    },
    mounted() {
        this.$bus.listen('esc', (dialogId) => {
            if (this.$el && this.$el.id === dialogId) {
                if (this.onCloseEsc) {
                    this.onCloseEsc();
                } else {
                    this.hide();
                }
            }
        })
    },

    watch: {
        visible() {
            if (this.visible) {
                this.$store.commit('hideComponent/add', this)
            } else {
                this.$store.commit('hideComponent/remove')
            }
        }
    },
}
</script>
